/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { IconBaseProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const Icon1C16 = forwardRef<SVGSVGElement, IconBaseProps>(function Icon1C16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path d="M0 7h1v5h1V6H0v1Z" fill="#C74343" />
            <path
                d="M1 5h2v7h1V4H1v1Zm5 3c0-1.654 1.346-3 3-3s3 1.346 3 3h1c0-2.206-1.794-4-4-4S5 5.794 5 8s1.794 4 4 4h7v-1H9c-1.654 0-3-1.346-3-3Z"
                fill="#C74343"
            />
            <path
                d="M9 9a1.001 1.001 0 0 1 0-2c.551 0 1 .448 1 1h1c0-1.103-.897-2-2-2s-2 .897-2 2 .897 2 2 2h7V9H9Z"
                fill="#C74343"
            />
        </SVGContainer>
    );
});

const Icon1C24 = forwardRef<SVGSVGElement, IconBaseProps>(function Icon1C24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path d="M0 9.6h1.6v8.8h1.6V8H0v1.6Z" fill="#C74343" />
            <path
                d="M1.6 7.2H4v11.2h1.6V5.6h-4v1.6ZM8.8 12c0-2.647 2.152-4.8 4.8-4.8 2.647 0 4.8 2.153 4.8 4.8H20c0-3.529-2.872-6.4-6.4-6.4A6.407 6.407 0 0 0 7.2 12c0 3.529 2.87 6.4 6.4 6.4H24v-1.6H13.6A4.805 4.805 0 0 1 8.8 12Z"
                fill="#C74343"
            />
            <path
                d="M13.6 13.6c-.882 0-1.6-.718-1.6-1.6 0-.882.718-1.6 1.6-1.6.883 0 1.6.718 1.6 1.6h1.6c0-1.765-1.435-3.2-3.2-3.2a3.203 3.203 0 0 0-3.2 3.2c0 1.765 1.436 3.2 3.2 3.2H24v-1.6H13.6Z"
                fill="#C74343"
            />
        </SVGContainer>
    );
});

export const Icon1C = forwardRef<SVGSVGElement, IconBaseProps>(function Icon1C(props, ref) {
    const { size = '16' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
    } as const;

    switch (size) {
        case '16':
            return <Icon1C16 {...iconProps} />;
        case '24':
            return <Icon1C24 {...iconProps} />;
        default:
            return <Icon1C24 {...iconProps} />;
    }
});
